<template>
  <div class="machine-main">
    <!-- 人工监测 -->
    <div class="first-content">
      <div class="div-line-veto">
        <div class="card-message-icon"></div>
        <div>单项否决</div>
      </div>
      <div class="message-div4"></div>
    </div>

    <div class="second-content">
      <div class="div-line-veto">
        <div class="card-message-icon"></div>
        <div>扣分指标</div>
      </div>
      <div class="message-div5"></div>
    </div>
  </div>
</template>
  <script>
export default {
  components: {},
  data() {
    return {};
  },
};
</script>
  <style lang="scss" scoped>
.machine-main {
  width: 100%;
  height: 100%;
}
.first-content {
  width: 100%;
  background-color: #fff;
  padding: 20px;
}
.second-content {
  width: 100%;
  background-color: #fff;
  padding: 20px;
  margin-top: 10px;
}
.message-div4 {
  width: 1030px;
  height: 404px;
  background: url('~@/assets/message4.png') center center no-repeat;
  background-size: contain;
}
.message-div5 {
  width: 1030px;
  height: 1000px;
  background: url('~@/assets/message5.png') center center no-repeat;
  background-size: 100% 100%;
}
</style>